// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"NginxSettingsList_contentComponent__3aXS-","tableContainer":"NginxSettingsList_tableContainer__1-QrS","root":"NginxSettingsList_root__1HRCQ"};